/* Tunizina Heimweh-Design 10.2026 – Tabs, Karteikarten, Quiz */
(function () {
  function initTabs(root) {
    root.querySelectorAll('[data-tzh-tabs]').forEach(function (wrap) {
      if (wrap.dataset.tzhReady) return;
      wrap.dataset.tzhReady = '1';
      var tabs = Array.prototype.slice.call(wrap.querySelectorAll('[data-tzh-tab]'));
      var panels = Array.prototype.slice.call(wrap.querySelectorAll('[data-tzh-panel]'));
      function show(i) {
        tabs.forEach(function (t) {
          var on = t.dataset.tzhTab === String(i);
          t.setAttribute('aria-selected', on ? 'true' : 'false');
          t.tabIndex = on ? 0 : -1;
        });
        panels.forEach(function (p) { p.hidden = p.dataset.tzhPanel !== String(i); });
      }
      tabs.forEach(function (t, idx) {
        t.addEventListener('click', function () { show(t.dataset.tzhTab); });
        t.addEventListener('keydown', function (e) {
          var k = e.key, n = null;
          if (k === 'ArrowRight' || k === 'ArrowDown') n = (idx + 1) % tabs.length;
          if (k === 'ArrowLeft' || k === 'ArrowUp') n = (idx - 1 + tabs.length) % tabs.length;
          if (n !== null) { e.preventDefault(); tabs[n].focus(); show(tabs[n].dataset.tzhTab); }
        });
      });
      show(tabs.length ? tabs[0].dataset.tzhTab : 0);
    });
  }

  function initFlip(root) {
    root.querySelectorAll('[data-tzh-flip]').forEach(function (card) {
      if (card.dataset.tzhReady) return;
      card.dataset.tzhReady = '1';
      card.addEventListener('click', function () {
        var on = !card.classList.contains('is-flipped');
        card.classList.toggle('is-flipped', on);
        card.setAttribute('aria-pressed', on ? 'true' : 'false');
      });
    });
  }

  function initQuiz(root) {
    root.querySelectorAll('[data-tzh-quiz]').forEach(function (quiz) {
      if (quiz.dataset.tzhReady) return;
      quiz.dataset.tzhReady = '1';
      var score = quiz.querySelector('[data-tzh-score]');
      var qs = Array.prototype.slice.call(quiz.querySelectorAll('[data-tzh-q]'));
      function update() {
        var done = 0, right = 0;
        qs.forEach(function (q) {
          if (q.dataset.answer !== undefined) { done++; if (q.dataset.answer === q.dataset.right) right++; }
        });
        if (!score) return;
        if (done < qs.length) { score.textContent = right + ' von ' + qs.length; return; }
        score.textContent = right === qs.length
          ? right + ' von ' + qs.length + ' – ' + (quiz.dataset.perfect || 'Mriguel!')
          : right + ' von ' + qs.length + ' – ' + (quiz.dataset.again || 'Weiter üben!');
      }
      qs.forEach(function (q) {
        var opts = Array.prototype.slice.call(q.querySelectorAll('[data-tzh-opt]'));
        var note = q.querySelector('[data-tzh-note]');
        opts.forEach(function (o) {
          o.addEventListener('click', function () {
            var pick = o.dataset.tzhOpt;
            q.dataset.answer = pick;
            opts.forEach(function (x) {
              x.classList.remove('is-right', 'is-wrong');
              if (x.dataset.tzhOpt === q.dataset.right) x.classList.add('is-right');
              else if (x === o) x.classList.add('is-wrong');
            });
            if (note) {
              var ok = pick === q.dataset.right;
              note.textContent = ok ? q.dataset.ok : q.dataset.no;
              note.className = 'tzh-quiz__note ' + (ok ? 'ok' : 'no');
              note.hidden = false;
            }
            update();
          });
        });
      });
      update();
    });
  }

  function init(root) { root = root || document; initTabs(root); initFlip(root); initQuiz(root); }
  if (document.readyState === 'loading') document.addEventListener('DOMContentLoaded', function () { init(); });
  else init();
  document.addEventListener('shopify:section:load', function (e) { init(e.target); });
})();
